import i18n from '@/libs/i18n'

export default [
  // *===============================================---*
  // *--------- USER ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/users/list',
    name: 'pages-users-list',
    component: () => import('@/views/pages/user/UsersList.vue'),
    meta: {
      action: 'read',
      resource: 'user',
      required: true,
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('users.mainVerticalMenu.users'),
    },
  },
  {
    path: '/users/edit/:id',
    name: 'pages-users-edit',
    component: () => import('@/views/pages/user/UserEdit.vue'),
    meta: {
      resource: 'user',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('users.mainVerticalMenu.users'),
    },
  },
  {
    path: '/roles/list',
    name: 'pages-roles-list',
    component: () => import('@/views/pages/role/RolesList.vue'),
    meta: {
      action: 'read',
      resource: 'role',
      required: true,
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('users.mainVerticalMenu.roles'),
    },
  },
  {
    path: '/roles/add',
    name: 'pages-roles-add',
    component: () => import('@/views/pages/role/RoleAdd.vue'),
    meta: {
      action: 'manage',
      resource: 'all',
      required: true,
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('users.mainVerticalMenu.addRole'),
    },
  },
  {
    path: '/roles/edit/:id',
    name: 'pages-roles-edit',
    component: () => import('@/views/pages/role/RoleEdit.vue'),
    meta: {
      action: 'manage',
      resource: 'all',
      required: true,
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('users.mainVerticalMenu.editRole'),
    },
  },
  {
    path: '/user/check',
    name: 'user-check-signUp',
    component: () => import('@/views/pages/userCheck/UserSignupCheck.vue'),
    meta: {
      action: 'read',
      resource: 'user',
      required: true,
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('users.countUserSignUp'),
    },
  },
]
